import { render, staticRenderFns } from "./ObjectivePemeriksaan.vue?vue&type=template&id=187135c7&scoped=true&"
import script from "./ObjectivePemeriksaan.vue?vue&type=script&lang=js&"
export * from "./ObjectivePemeriksaan.vue?vue&type=script&lang=js&"
import style0 from "./ObjectivePemeriksaan.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ObjectivePemeriksaan.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ObjectivePemeriksaan.vue?vue&type=style&index=2&id=187135c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187135c7",
  null
  
)

export default component.exports